import React, { useContext, useEffect, useState } from "react";

import { Box, Button, TextField, Typography } from "@mui/material";
import { getInvitation, register } from "../../api/ProcurementClient";
import { AppContext } from "../../AppContextProvider";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosError } from "axios";
import { QUEUE_URL } from "../../MainAppPanel";
import { NULL_USER } from "../../models/User";

const RegisrationPanel: React.FC = () => {
  const {
    setUser,
    setUsers,
    setCustomers,
    setSnackbarErrorMsg,
    setRfqs,
    setVendors,
  } = useContext(AppContext);

  const { inviteId } = useParams();
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmationPassword, setConfirmationPassword] = useState<string>("");

  useEffect(() => {
    // Allow invite links to work even if another account is already logged in
    localStorage.removeItem("jwtToken");
    setUser(NULL_USER);
    setUsers([]);
    setCustomers([]);

    const fetchInvitation = async () => {
      const user = await getInvitation(inviteId!);
      if (user) {
        setEmail(user.email);
        setFirstName(user.firstName);
        setLastName(user.lastName);
      }
    };
    fetchInvitation();
  }, []);

  const handleRegistration = async () => {
    try {
      const loginResponse = await register(
        inviteId!,
        userName,
        firstName,
        lastName,
        password,
        email
      );
      setUser(loginResponse.user);
      setUsers(loginResponse.users);
      setCustomers(loginResponse.customers);
      setRfqs(loginResponse.requestForQuotes);
      setVendors(loginResponse.vendors);

      localStorage.setItem("jwtToken", loginResponse.jwtToken);
      navigate(QUEUE_URL, { replace: true });
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.status === 401) {
        setSnackbarErrorMsg("Invalid username or password");
      } else {
        setSnackbarErrorMsg(
          "Unable to login: " +
          (axiosError.response?.data?.toString() ??
            axiosError.response?.statusText ??
            "Unknown server error")
        );
      }
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          flexBasis: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            padding: 2,
            display: "flex",
            gap: 2,
            flexDirection: "column",
            width: "80%",
            maxWidth: "400px",
          }}
        >
          <img
            src="/logo.jpg"
            style={{ display: "block", width: "100%", height: "auto" }}
            alt="logo"
          />
          <Typography textAlign="center" variant="h6">
            Lunch System Registration
          </Typography>

          <TextField
            fullWidth
            required
            label="First Name"
            variant="standard"
            value={firstName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setFirstName(event.target.value)
            }
          />
          <TextField
            fullWidth
            required
            label="Last Name"
            variant="standard"
            value={lastName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setLastName(event.target.value)
            }
          />
          <TextField
            fullWidth
            required
            error={
              (userName.length > 0 && userName.length < 5) ||
              /\s/.test(userName)
            }
            helperText="Minimum of 5 characters. No spaces allowed."
            label="Username"
            variant="standard"
            value={userName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setUserName(event.target.value)
            }
          />
          <TextField
            fullWidth
            label="Email"
            variant="standard"
            required
            value={email}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(event.target.value)
            }
          />

          <TextField
            fullWidth
            error={
              (password.length > 0 && password.length < 8) ||
              /\s/.test(password)
            }
            required
            helperText="Minimum of 8 characters. No spaces allowed."
            type="Password"
            label="Password"
            variant="standard"
            value={password}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setPassword(event.target.value)
            }
          />
          <TextField
            fullWidth
            required
            error={
              password.length &&
                confirmationPassword.length &&
                password !== confirmationPassword
                ? true
                : false
            }
            type="Password"
            label="Confirm Password"
            variant="standard"
            value={confirmationPassword}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setConfirmationPassword(event.target.value)
            }
          />
          <Button
            variant="contained"
            color="primary"
            disabled={
              !firstName.length ||
              !lastName.length ||
              !email.length ||
              userName.length < 5 ||
              /\s/.test(userName) ||
              password.length < 8 ||
              /\s/.test(password) ||
              password !== confirmationPassword
            }
            onClick={handleRegistration}
            sx={{
              marginTop: "50px",
            }}
          >
            Create Account
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RegisrationPanel;
